import React, { forwardRef, useState, useEffect, useRef } from 'react';
import logo from '../../../images/bluelogo.png';
import { requestNoteInfo } from '../../../services/newNotesRequest.js';
import Cookies from 'js-cookie';

const avoidPageBreakStyle = {
	breakInside: 'avoid',
	pageBreakInside: 'avoid',
	WebkitColumnBreakInside: 'avoid',
};

const textBlockClassName =
	'min-h-[80px] py-2 rounded-md whitespace-pre-wrap break-words';

const NewNotificacaoPDF = forwardRef(({ notificacao, onReady }, ref) => {
	const [noteInfo, setNoteInfo] = useState(null);
	const protocolo = notificacao?.protocolo;
	const onReadyRef = useRef(onReady);

	useEffect(() => {
		onReadyRef.current = onReady;
	}, [onReady]);

	// Prefere dados buscados da API; cai na prop como fallback
	const n = noteInfo ? { ...notificacao, ...noteInfo } : notificacao;

	useEffect(() => {
		let isMounted = true;
		const fetchNoteInfo = async () => {
			if (!protocolo) {
				onReadyRef.current?.();
				return;
			}

			try {
				setNoteInfo(null);
				const token = JSON.parse(Cookies.get('user') || '{}')?.token;
				if (!token) {
					onReadyRef.current?.();
					return;
				}
				const data = await requestNoteInfo(token, protocolo);
				if (isMounted) {
					setNoteInfo(data && !data.error ? data : null);
					onReadyRef.current?.();
				}
			} catch (error) {
				if (isMounted) {
					setNoteInfo(null);
					onReadyRef.current?.();
				}
			}
		};
		fetchNoteInfo();
		return () => {
			isMounted = false;
		};
	}, [protocolo]);

	return (
		<div
			ref={ref}
			className='p-[16px] w-[800px] bg-white font-inter'>
			{/* Header */}
			<div
				data-pdf-block='true'
				style={avoidPageBreakStyle}
				className='bg-[#F0F4F8] flex rounded-sm w-full content-center min-h-[120px] p-[16px] gap-[20px] justify-between lg:flex-row flex-col'>
				<div className='content-center items-center mx-auto'>
					<img
						className='w-[200px] h-auto'
						src={logo}
						alt='logo'
					/>
				</div>
				<p className='text-[24px] font-bold text-[#13335A] content-center max-w-[600px] text-center'>
					NOTIFICAÇÃO DE INCIDENTES E NÃO CONFORMIDADES
				</p>
			</div>
			{/* Form Sections */}
			<div className='flex flex-col gap-[16px] mt-[16px]'>
				{/* Unidade */}
				<div
					data-pdf-block='true'
					style={avoidPageBreakStyle}
					className='flex gap-[57px]'>
					{/* Unidade */}
					<div className='flex flex-col'>
						<p className='text-[#004A80] text-[16px] text-start font-medium'>
							Unidade
						</p>
						<div className='py-2 rounded-md flex items-center'>
							{n?.unidade_nome || 'não informado'}
						</div>
					</div>
					{/* Unidade */}
					<div className='flex flex-col'>
						<p className='text-[#004A80] text-[16px] text-start font-medium'>
							Nº da notificação
						</p>
						<div className='py-2 rounded-md flex items-center'>
							{n?.protocolo || 'não informado'}
						</div>
					</div>
				</div>

				{/* Datas e Setor */}
				<div
					data-pdf-block='true'
					style={avoidPageBreakStyle}
					className='flex gap-[16px] flex-col xl:flex-row text-start'>
					<div className='flex flex-col w-full'>
						<p className='text-[#004A80] text-[16px] font-medium'>
							Data da Notificação
						</p>
						<div className='h-[40px] py-2 rounded-md'>
							{n?.data_notificacao
								?.split('T')[0]
								.split('-')
								.reverse()
								.join('/') || 'não informado'}
						</div>
					</div>
					<div className='flex flex-col w-full'>
						<p className='text-[#004A80] text-[16px] font-medium'>
							Data da Ocorrência
						</p>
						<div className='h-[40px] py-2 rounded-md'>
							{n?.data_ocorrencia
								? n?.data_ocorrencia
										?.split('-')
										.reverse()
										.join('/')
								: 'não informado'}
						</div>
					</div>
					<div className='flex flex-col w-full'>
						<p className='text-[#004A80] text-[16px] font-medium'>
							Setor
						</p>
						<div className='max-h-[100px] py-2 rounded-md break-all'>
							{(n?.setor || 'não informado').length > 60
								? n?.setor.slice(0, 60) + '...'
								: n?.setor}
						</div>
					</div>
					<div className='flex flex-col w-full'>
						<p className='text-[#004A80] text-[16px] font-medium'>
							Turno
						</p>
						<div className='h-[40px] py-2 rounded-md'>
							{n?.turno_display}
						</div>
					</div>
				</div>

				{/* Paciente */}
				<div
					data-pdf-block='true'
					style={avoidPageBreakStyle}
					className='flex flex-col p-2 border-[2px] rounded-md border-[#F4F4F4] gap-[8px] text-start pb-3'>
					<div>
						<p className='text-[#004A80] text-[16px] font-medium'>
							Relacionado a paciente?
						</p>
						<div className='flex gap-[15px]'>
							<div>
								{n?.envolve_paciente === true ? 'Sim' : 'Não'}
							</div>
						</div>
					</div>

					{/* Detalhes paciente */}
					{n?.envolve_paciente === true && (
						<div className='flex gap-[16px] flex-col xl:flex-row mt-2 '>
							<div className='flex flex-col w-full mb-2'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Nome
								</p>
								<div>{n?.nome_paciente || 'não informado'}</div>
							</div>
							<div className='flex flex-col w-full'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Sexo
								</p>
								{/* {console.log(n)} */}
								<div>{n?.sexo_paciente_display}</div>
							</div>
							<div className='flex flex-col w-full'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Data de Nascimento
								</p>
								<div>
									{n?.nascimento_paciente
										? n?.nascimento_paciente
												.split('-')
												.reverse()
												.join('/')
										: 'não informado'}
								</div>
							</div>
							<div className='flex flex-col w-full'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Prontuário/BE
								</p>
								<div>{n?.prontuario || 'não informado'}</div>
							</div>
						</div>
					)}
				</div>

				{/* Incidentes */}
				<div
					data-pdf-block='true'
					style={avoidPageBreakStyle}
					className='flex flex-col p-2 border-[2px] rounded-md border-[#F4F4F4] gap-[8px] text-start'>
					<div className='flex gap-[16px] '>
						<div className='w-full my-2'>
							{' '}
							<p className='text-[#004A80] text-[16px] font-medium mb-1'>
								Incidentes e não conformidades
							</p>
							<div>
								{n?.tipo_incidente_display || 'não informado'}
							</div>
						</div>
						{n?.tipo_incidente_outros && (
							<div className='w-full'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Descrição do incidente
								</p>

								<div>
									{n?.tipo_incidente_outros ||
										'não informado'}
								</div>
							</div>
						)}
					</div>
					<div className='flex gap-[16px] my-[8px] bg-[#f3f7f8] p-2 rounded-md no-break '>
						<div className='flex flex-col w-full pb-2'>
							<p className='text-[#004A80] text-[16px] font-medium'>
								Presenciado por alguém?
							</p>
							<div>
								{n?.fato_presenciado === true ? 'Sim' : 'Não'}
							</div>
						</div>
						{n?.fato_presenciado === true && (
							<div className='flex flex-col w-full'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Nome
								</p>
								<div>
									{n?.quem_presenciou || 'não informado'}
								</div>
							</div>
						)}
					</div>
				</div>

				{/* Textareas como divs */}
				<div
					data-pdf-block='true'
					style={avoidPageBreakStyle}
					className='flex flex-col text-start no-break '>
					<p className='text-[#004A80] text-[16px] font-medium'>
						Descrição da ocorrência
					</p>
					<div className={textBlockClassName}>
						{n?.descricao || 'não informado'}
					</div>
				</div>
				<div
					data-pdf-block='true'
					style={avoidPageBreakStyle}
					className='flex flex-col text-start no-break '>
					<p className='text-[#004A80] text-[16px] font-medium'>
						Ações imediatas tomadas
					</p>
					<div className={textBlockClassName}>
						{n?.acoes_imediatas || 'não informado'}
					</div>
				</div>
				<div
					data-pdf-block='true'
					style={avoidPageBreakStyle}
					className='flex flex-col text-start no-break avoid-break-inside '>
					<p className='text-[#004A80] text-[16px] font-medium'>
						Medidas preventivas
					</p>
					<div className={textBlockClassName}>
						{n?.medida_preventiva || 'não informado'}
					</div>
				</div>
			</div>
		</div>
	);
});

export default NewNotificacaoPDF;
